import { useEffect } from 'react'

/**
 * Custom hook to protect against DevTools usage
 * - Disables right-click context menu
 * - Disables common DevTools keyboard shortcuts
 * - Detects when DevTools is open and shows warning overlay
 */
export const useDevToolsProtection = () => {
  useEffect(() => {
    const isLocalhost = Boolean(
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.endsWith('.localhost')
    )

    // Bypass DevTools protection on localhost or non-production environment
    if (process.env.NODE_ENV !== 'production' || isLocalhost) {
      // Clean up any previously appended warning elements
      const blurWrapper = document.getElementById('devtools-blur-wrapper')
      if (blurWrapper) {
        while (blurWrapper.firstChild) {
          document.body.appendChild(blurWrapper.firstChild)
        }
        blurWrapper.remove()
      }
      const overlay = document.getElementById('devtools-warning')
      if (overlay) {
        overlay.remove()
      }
      return
    }

    const disableRightClick = (e: MouseEvent) => {
      e.preventDefault()
    }

    // Disable common keyboard shortcuts for DevTools
    const disableDevToolsShortcuts = (e: KeyboardEvent) => {
      // F12
      if (e.keyCode === 123) {
        e.preventDefault()
        return false
      }
      // Ctrl+Shift+I or Cmd+Opt+I (Inspect Element)
      if ((e.ctrlKey && e.shiftKey && e.keyCode === 73) || (e.metaKey && e.altKey && e.keyCode === 73)) {
        e.preventDefault()
        return false
      }
      // Ctrl+Shift+J or Cmd+Opt+J (Console)
      if ((e.ctrlKey && e.shiftKey && e.keyCode === 74) || (e.metaKey && e.altKey && e.keyCode === 74)) {
        e.preventDefault()
        return false
      }
      // Ctrl+Shift+C or Cmd+Opt+C (Inspect Element)
      if ((e.ctrlKey && e.shiftKey && e.keyCode === 67) || (e.metaKey && e.altKey && e.keyCode === 67)) {
        e.preventDefault()
        return false
      }
      // Ctrl+U or Cmd+U (View Source)
      if ((e.ctrlKey && e.keyCode === 85) || (e.metaKey && e.keyCode === 85)) {
        e.preventDefault()
        return false
      }
    }

    // Detect if DevTools is open by checking window size differences
    const detectDevTools = () => {
      const threshold = 160
      const widthThreshold = window.outerWidth - window.innerWidth > threshold
      const heightThreshold = window.outerHeight - window.innerHeight > threshold

      if (widthThreshold || heightThreshold) {
        // DevTools detected - take aggressive action
        const overlay = document.getElementById('devtools-warning')
        if (!overlay) {
          // Create blur wrapper for content
          const contentWrapper = document.createElement('div')
          contentWrapper.id = 'devtools-blur-wrapper'
          contentWrapper.style.cssText = `
            filter: blur(10px);
            pointer-events: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 999998;
          `

          // Move all body children into wrapper
          while (document.body.firstChild) {
            contentWrapper.appendChild(document.body.firstChild)
          }
          document.body.appendChild(contentWrapper)

          // Create clear warning overlay on top
          const warningDiv = document.createElement('div')
          warningDiv.id = 'devtools-warning'
          warningDiv.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.95);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 999999;
            color: white;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            flex-direction: column;
          `
          warningDiv.innerHTML = `
            <div>⚠️ Developer Tools Detected</div>
            <div style="font-size: 16px; margin-top: 20px;">Please close Developer Tools and refresh the page to continue</div>
          `
          document.body.appendChild(warningDiv)
        }
      } else {
        // DevTools closed - restore normal view
        const blurWrapper = document.getElementById('devtools-blur-wrapper')
        if (blurWrapper) {
          // Move children back to body
          while (blurWrapper.firstChild) {
            document.body.appendChild(blurWrapper.firstChild)
          }
          blurWrapper.remove()
        }

        const overlay = document.getElementById('devtools-warning')
        if (overlay) {
          overlay.remove()
        }
      }
    }

    // Disable right-click anywhere on the page
    window.addEventListener('contextmenu', disableRightClick)

    // Disable keyboard shortcuts
    window.addEventListener('keydown', disableDevToolsShortcuts)

    // Check for DevTools periodically - ENABLED for active protection
    const devToolsInterval = setInterval(detectDevTools, 1000)

    return () => {
      window.removeEventListener('contextmenu', disableRightClick)
      window.removeEventListener('keydown', disableDevToolsShortcuts)
      clearInterval(devToolsInterval)
    }
  }, [])
}
